import { render } from "./ExpendRules.vue?vue&type=template&id=7881b336&scoped=true"
import script from "./ExpendRules.vue?vue&type=script&lang=js"
export * from "./ExpendRules.vue?vue&type=script&lang=js"

import "./ExpendRules.vue?vue&type=style&index=0&id=7881b336&scoped=true&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7881b336"]])

export default __exports__